import ZwxLocalStorage from './local-storage'

/**
 * 换肤
 * */
let changeSkin = skin => {
  const win = window.top === undefined || window.top === null || window.top.vm === undefined || window.top.vm === null ? window : window.top
  if (win !== window) window.vm.$store.commit('INIT_SKIN', skin)
  win.vm.$store.commit('INIT_SKIN', skin)
  ZwxLocalStorage.addLocalStorage('zwx-skin-theme', skin)
}

/**
 * 获取当前皮肤
 * */
let getCurrentSkin = () => {
  const win = window.top === undefined || window.top === null || window.top.vm === undefined || window.top.vm === null ? window : window.top
  return win.vm.$store.state.skin
}

export default { changeSkin, getCurrentSkin }
